import { type Component } from 'solid-js'
import chorusLogo from '../assets/images/chorus-logo.svg'

const LoadingScreen: Component = () => {
  return (
    <div class="w-full bg-blue_gray-100 flex items-center justify-center h-full">
      <img src={chorusLogo} alt="Chorus" class="w-[115px]" />
    </div>
  )
}

export default LoadingScreen
